export const NEWRELIC_TABLES = {
    PORTAL_SWIGGY_MONEY_PAYMENT_INITIAL_STATE: "portal_swiggy_money_payment_initial_state",
    PORTAL_SWIGGY_MONEY_IMPRESSION: "portal_swiggy_money_impression",
    PORTAL_SWIGGY_MONEY_ERROR_IMPRESSION: "portal_swiggy_money_error_impression",
    PORTAL_SWIGGY_MONEY_API: "portal_swiggy_money_api",
    PORTAL_SWIGGY_MONEY_API_ERROR: "portal_swiggy_money_api_error",
    PORTAL_SWIGGY_MONEY_CLAIM_ERROR: "portal_swiggy_money_claim_error",
    PORTAL_SWIGGY_MONEY_WEBNAVIGATE: "portal_swiggy_money_webnavigate",
};
